import Box from "@mui/material/Box";

import {MapMenu} from "base/component/geo/menu";
import {LayerMenu, TileLayerMenu} from "base/component/geo";
import {ImageOverlayLayer, TileLayer} from "base/map";
import AccordionLayout from "base/component/presentational/AccordionLayout";
import {getGroupTitleStyle} from "base/component/geo/menu/MapMenu";
import {useMainMapProvider} from "../../main/map/MainMapProvider";

const isLayerVisible = layerProvider => layerProvider.included === true;
const isGroupVisible = group => {
    if (group.layers && group.layers.some(isLayerVisible)) return true;
    if (group.children && group.children.some(isGroupVisible)) return true;
    return false;
};

const getLayerItem = (layerProvider, index) => {
    if (
        layerProvider.layer instanceof TileLayer ||
        layerProvider.layer instanceof ImageOverlayLayer
    ) {
        return <TileLayerMenu key={index} layerProvider={layerProvider} />;
    }
    return <LayerMenu key={index} layerProvider={layerProvider} />;
};

function RecursiveLayerMenu({group, level = 0}) {
    if (!isGroupVisible(group)) return null;
    const content = [];
    if (group.layers) {
        group.layers.forEach((layerProvider, idx) => {
            if (isLayerVisible(layerProvider)) {
                content.push(getLayerItem(layerProvider, idx));
            }
        });
    }
    if (group.children) {
        group.children.forEach((child, idx) => {
            const childNode = (
                <RecursiveLayerMenu
                    key={child.name + idx}
                    group={child}
                    level={level + 1}
                />
            );
            if (childNode) content.push(childNode);
        });
    }
    if (content.length === 0) return null;
    const groupTitleStyle = getGroupTitleStyle(level);
    // Extract only valid CSS properties for inline style
    const {fontSize, fontWeight} = groupTitleStyle;
    // Use spacing props in Box sx
    const {pl, py, mb} = groupTitleStyle;
    const {textTransform} = groupTitleStyle;
    return (
        <AccordionLayout
            detailsStyle={{pl: 0.2}}
            accordionTitle={
                <Box sx={{textTransform}} component="span">
                    <span style={{fontSize, fontWeight}}>{group.name}</span>
                </Box>
            }
        >
            <Box sx={{pl, py, mb}}>{content}</Box>
        </AccordionLayout>
    );
}

export const MainMapMenu = () => {
    const {getMenuSections} = useMainMapProvider();
    return (
        <MapMenu>
            {getMenuSections().map((section, idx) => (
                <RecursiveLayerMenu key={section.name + idx} group={section} />
            ))}
        </MapMenu>
    );
};
